// extracted by mini-css-extract-plugin
module.exports = {"PageTitle":"PageTitle_PageTitle__2pL08","title1":"PageTitle_title1__3eLPF","signedInTitle1":"PageTitle_signedInTitle1__2XSSC","title2":"PageTitle_title2__97Iwg"};